/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PageRequest } from './PageRequest';
import {
    PageRequestFromJSON,
    PageRequestFromJSONTyped,
    PageRequestToJSON,
} from './PageRequest';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
} from './SortOrder';

/**
 * 
 * @export
 * @interface SearchRoleRequest
 */
export interface SearchRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchRoleRequest
     */
    pattern: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchRoleRequest
     */
    filter?: Array<number>;
    /**
     * Zero-based page index.
     * @type {number}
     * @memberof SearchRoleRequest
     */
    page: number;
    /**
     * Requested records per page. The server caps this value at 100.
     * @type {number}
     * @memberof SearchRoleRequest
     */
    pageSize: number;
    /**
     * Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.
     * @type {string}
     * @memberof SearchRoleRequest
     */
    sortBy?: string;
    /**
     * 
     * @type {SortOrder}
     * @memberof SearchRoleRequest
     */
    sortOrder?: SortOrder;
}

/**
 * Check if a given object implements the SearchRoleRequest interface.
 */
export function instanceOfSearchRoleRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pattern" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "pageSize" in value;

    return isInstance;
}

export function SearchRoleRequestFromJSON(json: any): SearchRoleRequest {
    return SearchRoleRequestFromJSONTyped(json, false);
}

export function SearchRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pattern': json['pattern'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
        'page': json['page'],
        'pageSize': json['pageSize'],
        'sortBy': !exists(json, 'sortBy') ? undefined : json['sortBy'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : SortOrderFromJSON(json['sortOrder']),
    };
}

export function SearchRoleRequestToJSON(value?: SearchRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pattern': value.pattern,
        'filter': value.filter,
        'page': value.page,
        'pageSize': value.pageSize,
        'sortBy': value.sortBy,
        'sortOrder': SortOrderToJSON(value.sortOrder),
    };
}

